import GpParser from "../../gpParser";
import { CATEGORIES } from "../../configuration/constants";
import Headline from "./Headline";
import Headline1 from "./Headline1";
import Tag from "./Tag";
import Text from "./Text";
import HorizontalRule from './HorizontalRule'
import Box from "./Box";
import Iframe from "./Iframe";
import ButtonGroup from "./ButtonGroup";
import CustomTime from "./CustomTime";
import Weather from "./Weather";
import CustomCarousel from "./CustomCarousel";
import CircularProgress from "./CircularProgress";
import JSONViewer from './JSONViewer'
import TextGroup from "./TextGroup";
import CurrentTime from "./CurrentTime";

export default (editor, options) => {
  GpParser.loadFromList(
    [
      Box,
      Text,
      Headline,
      Headline1,
      Tag,
      Iframe,
      HorizontalRule,
      ButtonGroup,
      CustomTime,
      Weather,
      CustomCarousel,
      CircularProgress,
      JSONViewer,
      TextGroup,
      CurrentTime,
    ],
    CATEGORIES.COMMON,
    editor,
    options
  );
};
